define.alias("ember-cli-string-helpers/helpers/w", "calendar/helpers/w");